export type Radii = typeof radii;

export const radii = {
  none: '0px',
  rounded: '4px',
  large: '20px',
  circle: '50%',
} as const;
